import React, {FunctionComponent, PropsWithChildren} from "react";
import {Link, LinkProps} from "react-router-dom";
import {styled, Button, ButtonProps} from "@reside/ui";

type Props = Readonly<Omit<ButtonProps, "title"> & Pick<LinkProps, "to">>;

const PlainLink = styled(Link)`
  display: inline-block;
  text-decoration: none;
`;

export const ButtonLink: FunctionComponent<PropsWithChildren<Props>> = ({
  children,
  to,
  disabled = false,
  outline = true,
  color = "primary",
  ...buttonProps
}) => {
  if (disabled) {
    return (
      <Button disabled {...buttonProps}>
        {children}
      </Button>
    );
  }

  return (
    <PlainLink to={to}>
      <Button outline={outline} color={color} {...buttonProps}>
        {children}
      </Button>
    </PlainLink>
  );
};
